module.exports = __webpack_public_path__ + "img/loading-item-success@3x.da74efb9.png";